import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface IGroupedProductIdTokenUsage {
  tokenUsageByResourceProductId: Record<string, number>;
  totalTokenUsage: number;
}

export interface IGroupedTenantIdTokenUsage {
  tenantId: string;
  groupedModelTokenUsage: Record<string, number>;
  groupedProductIdTokenUsage: Record<string, IGroupedProductIdTokenUsage>;
  groupedUserIdTokenUsage: Record<string, number>;
  totalTokenUsage: number;
}

export interface ITokenUsage {
  tokenUsageLimit: number;
}

@Injectable({
  providedIn: 'root'
})
export class TokenUsageService {
  private readonly baseUrl = environment.ntIntegrationApiUrl;

  constructor(private http: HttpClient) { }

  public getTokenUsageForDate(date: string): Observable<IGroupedTenantIdTokenUsage> {
    return this.http.get<IGroupedTenantIdTokenUsage>(`${this.baseUrl}/token-usage?date=${date}`);
  }

  public getTokenUsageLimit(): Observable<ITokenUsage> {
    return this.http.get<ITokenUsage>(`${this.baseUrl}/token-usage-limit`);
  }
}
